const feeds = {
    "Polygon": "https://www.polygon.com/feed/news/",
    "Siliconera": "https://www.siliconera.com/feed/",
    "C-OSSU (Reddit)": "https://www.reddit.com/user/C-OSSU/.rss"
}
export default feeds;